var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.to}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{class:`${_vm.betaTag ? 'beta-tag' : ''}`,attrs:{"alt":_vm.alt,"height":_vm.height,"src":"/Icon CC_thin_color.svg","contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }